module.exports = __webpack_public_path__ + "static/media/nguyen_thanh_hoa.1d0712f4.jpg";